export default __webpack_public_path__ + "static/0-22a5ad585bd09c4bc3de0b8015b1148c.jpg";